import { Directive, effect, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@services/user.service';

@Directive({
  selector: '[hideIPausedOrCancelled]',
  standalone: false,
})
export class HideIfPausedOrCancelledDirective {
  constructor(
    private userService: UserService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    effect(() => {
      const subscriptionData = this.userService.companySubscription();
      if (subscriptionData?.status === 'paused' || subscriptionData?.pause_collection !== null) {
        this.viewContainer.clear();
        return;
      } else {
        if (this.viewContainer.length === 0) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      }
    });
  }
}
